<template lang="pug">
  .coach-review-list
    template(v-if="rating == 0")
      span.no-data {{ 'まだレビューがありません' }}
    template(v-else)
      rating-star(:rating="rating")
      span {{ numberFormat(reviewCount) }}
</template>

<style lang="scss" scoped>
.coach-review-list {
  span {
    @extend %label-text;
    margin-left: 4px;
  }
  .no-data {
    font-weight: 300;
  }
}
</style>

<script>
import RatingStar from '@/components/atoms/RatingStar'
import Formatter from '@/components/mixins/Formatter'

export default {
  components: { RatingStar },
  mixins: [Formatter],
  props: {
    rating: {
      type: Number,
      required: true,
    },
    reviewCount: {
      type: Number,
      required: true,
    },
  },
}
</script>
